import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private toastr: ToastrService) {
  }

  showSuccess(message, title) {
    this.toastr.success(message, title);
  }

  showError(message, title) {
    this.toastr.error(message, title);
  }
  showWarning(message, title) {
    this.toastr.warning(message, title);
  }

  showStickyWarning(message: string, title?: string) {
    this.toastr.warning(message, title, {
      disableTimeOut: true,       
      closeButton: true,
      tapToDismiss: false,        
      enableHtml: true,           
      toastClass: 'ngx-toastr toast-wide',
      titleClass: 'toast-title readable-title',
      messageClass: 'toast-message readable-message',
      positionClass: 'toast-top-right' 
    });
  }

}
